// extracted by mini-css-extract-plugin
module.exports = {"skillsContainer":"style_skillsContainer__30N4T","skillTitle":"style_skillTitle__sJg-L"};